import { z } from 'zod'

export const resetPasswordSchema = z.object({
  token: z.string().min(1, "Token requis"),
  newPassword: z.string().min(6, "Au moins 6 caractères"),
  confirmNewPassword: z.string().min(6, "Au moins 6 caractères"),
}).refine((data) => data.newPassword === data.confirmNewPassword, {
  message: "Les mots de passe ne correspondent pas",
  path: ["confirmNewPassword"],
})


